import {Injectable} from '@angular/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class CodeSearchDaoService extends BaseDaoService {
  constructor() {
    super();
  }

  getSearchResults({refModel, refModelNode, type, search, sort, skip, limit}, body: any) {
    const queryParams: any = {};

    if (refModelNode !== undefined) {
      queryParams.rmn = refModelNode;
    }

    if (type !== undefined) {
      queryParams.type = type;
    }

    if (search !== undefined) {
      queryParams.search = search;
    }

    if (sort && sort.dir && sort.field) {
      queryParams.sortBy = sort.field;
      queryParams.sort = sort.dir;
    }

    if (skip !== undefined) {
      queryParams.skip = skip;
    }

    if (limit !== undefined) {
      queryParams.limit = limit;
    }

    return this.http.post<any>(`${this.apiUrl}/code-search/rm/${refModel}/search`, body, {
      params: queryParams
    });
  }
}
